import { Action } from '@ngrx/store';

import { Account } from 'modules/shared/models/account.models';
import { BaseListReqParams } from 'modules/shared/models/base.models';
import {
  AccountListResponse, AccountPayload, CreateAccountPayload, GroupPermissionResponse,
  UpdateRoleActionPayload, AccountBatchUploadPayload
} from 'store/models/admin.models';

export enum AdminActionTypes {
  GET_ALL_ACCOUNTS = 'GET_ALL_ACCOUNTS',
  GET_ALL_ACCOUNTS_SUCCESS = 'GET_ALL_ACCOUNTS_SUCCESS',
  GET_ALL_ACCOUNTS_FAILURE = 'GET_ALL_ACCOUNTS_FAILURE',
  GET_ACCOUNTS_IN_CURRENT_DOMAIN = 'GET_ACCOUNTS_IN_CURRENT_DOMAIN',
  GET_ACCOUNTS_IN_CURRENT_DOMAIN_SUCCESS = 'GET_ACCOUNTS_IN_CURRENT_DOMAIN_SUCCESS',
  GET_ACCOUNTS_IN_CURRENT_DOMAIN_FAILURE = 'GET_ACCOUNTS_IN_CURRENT_DOMAIN_FAILURE',
  GET_PERMISSIONS = 'GET_PERMISSIONS',
  GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS',
  GET_PERMISSIONS_FAILURE = 'GET_PERMISSIONS_FAILURE',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS',
  CREATE_ACCOUNT_FAILURE = 'CREATE_ACCOUNT_FAILURE',
  UPDATE_ROLES = 'UPDATE_ROLES',
  UPDATE_ROLES_SUCCESS = 'UPDATE_ROLES_SUCCESS',
  UPDATE_ROLES_FAILURE = 'UPDATE_ROLES_FAILURE',
  ACCOUNT_BATCH_UPLOAD = 'ACCOUNT_BATCH_UPLOAD',
  ACCOUNT_BATCH_UPLOAD_SUCCESS = 'ACCOUNT_BATCH_UPLOAD_SUCCESS',
  ACCOUNT_BATCH_UPLOAD_FAILURE = 'ACCOUNT_BATCH_UPLOAD_FAILURE',
}

export class GetAllAccounts implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_ALL_ACCOUNTS;
  constructor(public payload?: AccountPayload) {}
}

export class GetAllAccountsSuccess implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_ALL_ACCOUNTS_SUCCESS;
  constructor(public payload: AccountListResponse = null) {}
}

export class GetAllAccountsFailure implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_ALL_ACCOUNTS_FAILURE;
  constructor(public payload: any = null) {}
}

export class GetAccountsInCurrentDomain implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN;
  constructor(public payload?: AccountPayload) {}
}

export class GetAccountsInCurrentDomainSuccess implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN_SUCCESS;
  constructor(public payload: AccountListResponse = null) {}
}

export class GetAccountsInCurrentDomainFailure implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_ACCOUNTS_IN_CURRENT_DOMAIN_FAILURE;
  constructor(public payload: any = null) {}
}

export class GetPermissions implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_PERMISSIONS;
  constructor(public payload?: BaseListReqParams) {}
}

export class GetPermissionsSuccess implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_PERMISSIONS_SUCCESS;
  constructor(public payload: GroupPermissionResponse = null) {}
}

export class GetPermissionsFailure implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.GET_PERMISSIONS_FAILURE;
  constructor(public payload: any = null) {}
}

export class CreateAccount implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.CREATE_ACCOUNT;
  constructor(public payload?: CreateAccountPayload) {}
}

export class CreateAccountSuccess implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.CREATE_ACCOUNT_SUCCESS;
  constructor(public payload: Account = null) {}
}

export class CreateAccountFailure implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.CREATE_ACCOUNT_FAILURE;
  constructor(public payload: any = null) {}
}

export class UpdateRoles implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.UPDATE_ROLES;
  constructor(public payload?: any) {}
}

export class UpdateRolesSuccess implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.UPDATE_ROLES_SUCCESS;
  constructor(public payload: UpdateRoleActionPayload = null) {}
}

export class UpdateRolesFailure implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.UPDATE_ROLES_FAILURE;
  constructor(public payload: any = null) {}
}

export class AccountBatchUpload implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.ACCOUNT_BATCH_UPLOAD;
  constructor(public payload?: AccountBatchUploadPayload) {}
}

export class AccountBatchUploadSuccess implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.ACCOUNT_BATCH_UPLOAD_SUCCESS;
  constructor(public payload: Account[] = null) {}
}

export class AccountBatchUploadFailure implements Action {
  readonly type: AdminActionTypes = AdminActionTypes.ACCOUNT_BATCH_UPLOAD_FAILURE;
  constructor(public payload: any = null) {}
}

export type AdminActions =
  | GetAllAccounts
  | GetAllAccountsSuccess
  | GetAllAccountsFailure
  | GetAccountsInCurrentDomain
  | GetAccountsInCurrentDomainSuccess
  | GetAccountsInCurrentDomainFailure
  | GetPermissions
  | GetPermissionsSuccess
  | GetPermissionsFailure
  | CreateAccount
  | CreateAccountSuccess
  | CreateAccountFailure
  | UpdateRoles
  | UpdateRolesSuccess
  | AccountBatchUpload
  | AccountBatchUploadSuccess;
